import { call, put, takeLatest } from "redux-saga/effects";
import * as api from "../constants/api";
import {
  SG_GET_SLACK_EVENT_RESPONSE,
  GET_SLACK_EVENT_RESPONSE,
  SG_ADD_SLACK_EVENT_RESPONSE,
  ADD_SLACK_EVENT_RESPONSE,
  SG_EDIT_SLACK_EVENT_RESPONSE,
  EDIT_SLACK_EVENT_RESPONSE,
  SG_DELETE_SLACK_EVENT_RESPONSE,
  DELETE_SLACK_EVENT_RESPONSE,
  PENDING_SLACK_EVENT_RESPONSE,
  ALL_ERRORS,
} from "../constants/actions";

function* fetchSlackEventResponse(action) {
  try {
    yield put({ type: PENDING_SLACK_EVENT_RESPONSE });
    const response = yield call(api.GET_SLACK_EVENT_RESPONSE, action.payload);
    yield put({ type: GET_SLACK_EVENT_RESPONSE, payload: response.data });
  } catch (error) {
    yield put({ type: ALL_ERRORS, payload: error.response });
  }
}

function* addSlackEventResponse(action) {
  try {
    yield put({ type: PENDING_SLACK_EVENT_RESPONSE });
    const response = yield call(api.ADD_SLACK_EVENT_RESPONSE, action.payload);
    yield put({ type: ADD_SLACK_EVENT_RESPONSE, payload: response.data });
  } catch (error) {
    yield put({ type: ALL_ERRORS, payload: error.response });
  }
}

function* editSlackEventResponse(action) {
  try {
    yield put({ type: PENDING_SLACK_EVENT_RESPONSE });
    const response = yield call(api.EDIT_SLACK_EVENT_RESPONSE, action.payload);
    yield put({ type: EDIT_SLACK_EVENT_RESPONSE, payload: response.data });
  } catch (error) {
    yield put({ type: ALL_ERRORS, payload: error.response });
  }
}

function* deleteSlackEventResponse(action) {
  try {
    yield put({ type: PENDING_SLACK_EVENT_RESPONSE });
    const response = yield call(api.DELETE_SLACK_EVENT_RESPONSE, action.payload);
    yield put({ type: DELETE_SLACK_EVENT_RESPONSE, payload: response.data });
  } catch (error) {
    yield put({ type: ALL_ERRORS, payload: error.response });
  }
}

export default function* slackEventResponseSaga() {
  yield takeLatest(SG_GET_SLACK_EVENT_RESPONSE, fetchSlackEventResponse);
  yield takeLatest(SG_ADD_SLACK_EVENT_RESPONSE, addSlackEventResponse);
  yield takeLatest(SG_EDIT_SLACK_EVENT_RESPONSE, editSlackEventResponse);
  yield takeLatest(SG_DELETE_SLACK_EVENT_RESPONSE, deleteSlackEventResponse);
}